import { collection, doc, getDoc, getDocs, orderBy, query, where } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';

async function getUsersByCompanyId(companyId: string): Promise<UserDoc[]> {
  try {
    const db = firestore;

    const company = await getDoc(doc(db, FirestoreCollections.companies, companyId));
    const idSubscriptions = Object.keys(company.data()?.id_subscriptions || {});

    const usersCollection = collection(db, FirestoreCollections.users);

    // 1. Find users linked directly to the company via id_companies (e.g. users without a number).
    // 2. Find users linked via a subscription (partner API / reassignSubscription flows can add a
    // user to a subscription without setting id_companies), one query per subscription.
    const [companyMembersResult, subscriptionMembersResults] = await Promise.all([
      getDocs(query(usersCollection, orderBy(`id_companies.${companyId}`, 'asc'))),
      Promise.all(
        idSubscriptions.map(subscriptionId =>
          getDocs(query(usersCollection, orderBy(`id_subscription.${subscriptionId}`, 'asc')))
        )
      ),
    ]);
    const companyMembers = companyMembersResult.docs.map((doc) => UserDoc.fromFirestore(doc));
    const subscriptionMembers = subscriptionMembersResults.flatMap(result =>
      result.docs.map((doc) => UserDoc.fromFirestore(doc))
    );

    const allUsers = [...companyMembers, ...subscriptionMembers];

    // Remove dubblons (user with several numbers will be retrieved several times -> is it possible to improve ?)
    const filteredUsers = allUsers.filter((user, index, array) => {
      return array.findIndex(t => t.id === user.id) === index;
    });

    return filteredUsers;
  } catch (e) {
    console.error('error: ', e);
    throw new GetUsersByCompanyIdFailure();
  }
}

export class GetUsersByCompanyIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUsersByCompanyId;
